/* ============================================================
   LAB EFFECTS — Blog index behaviour
   1) Grid: the section server-paginates 15 articles per page with real
      ?page=N URLs. Category chips link to /blogs/news/tagged/<tag> and the
      search box posts to Shopify's native article search, so both reach the
      whole blog. JS only re-sorts the page that is already on screen.
   2) Newsletter: AJAX subscribe to a Klaviyo list (company id + list id
      from the theme editor). Falls back to a native Shopify customer
      form when Klaviyo isn't configured.
   ============================================================ */
(function () {
  /* ---------------------------- GRID ---------------------------- */
  /* The grid is server-paginated (15/page) for SEO and no-JS, but filtering and
     search are AJAX: the first time the reader touches a chip or the search box
     we pull the remaining pages once, cache every card, and from then on filter
     instantly in place. No reload, no scroll jump, and the whole blog is
     searchable — not just the 15 cards the server happened to send. */
  function initGrid(root) {
    if (root.hasAttribute('data-bl-ready')) return;
    root.setAttribute('data-bl-ready', '');
    var grid = root.querySelector('[data-bl-grid]');
    if (!grid) return;

    var wrap      = root.querySelector('[data-bl-gridwrap]');
    var countEl   = root.querySelector('[data-bl-count]');
    var searchEl  = root.querySelector('[data-bl-search]');
    var searchFrm = root.querySelector('form.bl-search-mini');
    var sortSel   = root.querySelector('[data-bl-sort]');
    var filters   = root.querySelector('[data-bl-filters]');
    var filterSel = root.querySelector('[data-bl-filter-select]');
    var pager     = root.querySelector('.bl-pager');
    var resetBtn  = root.querySelector('[data-bl-reset]');
    var loadWrap  = root.querySelector('[data-bl-loadwrap]');
    var loadBtn   = root.querySelector('[data-bl-loadmore]');

    var blogUrl    = root.getAttribute('data-blog-url') || '/blogs/news';
    var totalPages = parseInt(root.getAttribute('data-total-pages'), 10) || 1;

    var activeCat = 'all';
    var query     = '';
    var allCards  = null;       // every card in the blog, fetched lazily
    var loading   = null;       // in-flight promise
    var pageCards = [].slice.call(grid.querySelectorAll('.bl-card'));

    /* ---- pull the pages we don't have, once ---- */
    function ensureAll() {
      if (allCards) return Promise.resolve(allCards);
      if (loading) return loading;
      var wanted = [];
      for (var p = 2; p <= totalPages; p++) wanted.push(p);
      loading = Promise.all(wanted.map(function (p) {
        return fetch(blogUrl + '?page=' + p, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var seen = {}, out = [];
        function push(card) {
          var k = card.getAttribute('data-title') + '|' + card.getAttribute('data-date');
          if (seen[k]) return;
          seen[k] = 1; out.push(card);
        }
        pageCards.forEach(push);
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          [].slice.call(doc.querySelectorAll('.bl-card')).forEach(push);
        });
        allCards = out;
        return out;
      });
      return loading;
    }

    function haystack(card) {
      return ((card.getAttribute('data-title') || '') + ' ' +
              (card.getAttribute('data-keywords') || '') + ' ' +
              (card.textContent || '')).toLowerCase();
    }

    function matches(card) {
      var catOk = activeCat === 'all' ||
        (' ' + (card.getAttribute('data-cats') || '') + ' ').indexOf(' ' + activeCat + ' ') !== -1;
      var qOk = !query || haystack(card).indexOf(query) !== -1;
      return catOk && qOk;
    }

    function sortList(arr) {
      var mode = sortSel ? sortSel.value : 'newest';
      return arr.slice().sort(function (a, b) {
        if (mode === 'az') {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        }
        var da = a.getAttribute('data-date') || '', db = b.getAttribute('data-date') || '';
        return mode === 'oldest' ? da.localeCompare(db) : db.localeCompare(da);
      });
    }

    /* ---- render: always a windowed list with a Load-more button ---- */
    var STEP  = 15;
    var shown = STEP;

    function visibleSet() {
      return sortList((allCards || pageCards).filter(matches));
    }

    function render() {
      var hits = visibleSet();
      var slice = hits.slice(0, shown);
      grid.innerHTML = '';
      slice.forEach(function (c) { grid.appendChild(c); });
      if (wrap) wrap.classList.toggle('is-empty', hits.length === 0);
      if (pager) pager.style.display = 'none';          // JS owns paging now
      if (loadWrap) {
        var more = hits.length > slice.length;
        loadWrap.hidden = !more;
        loadWrap.style.display = more ? '' : 'none';
      }
      if (countEl) {
        countEl.style.display = hits.length === 0 ? 'none' : '';
        countEl.innerHTML = 'Showing <b>' + slice.length + '</b> of <b>' + hits.length +
          '</b> article' + (hits.length === 1 ? '' : 's') +
          (query ? ' matching &ldquo;' + query.replace(/[<>&]/g, '') + '&rdquo;' : '');
      }
    }

    function update(resetWindow) {
      if (resetWindow !== false) shown = STEP;
      ensureAll().then(render);
    }

    /* ---- chips: filter in place, never navigate ---- */
    if (filters) filters.addEventListener('click', function (e) {
      var chip = e.target.closest('.bl-chip');
      if (!chip || !chip.hasAttribute('data-cat')) return;
      e.preventDefault();                                // no reload, no scroll jump
      activeCat = chip.getAttribute('data-cat');
      filters.querySelectorAll('.bl-chip').forEach(function (b) {
        b.classList.toggle('active', b === chip);
      });
      if (filterSel) filterSel.value = activeCat;
      var url = activeCat === 'all' ? blogUrl : chip.getAttribute('href');
      if (window.history && history.replaceState) history.replaceState(null, '', url);
      update();
    });

    if (filterSel) filterSel.addEventListener('change', function () {
      activeCat = filterSel.value;
      if (filters) filters.querySelectorAll('.bl-chip').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-cat') === activeCat);
      });
      update();
    });

    /* ---- search: live as you type, never submits ---- */
    if (searchFrm) searchFrm.addEventListener('submit', function (e) { e.preventDefault(); });
    if (searchEl) {
      var t = null;
      var onType = function () {
        clearTimeout(t);
        t = setTimeout(function () {
          query = searchEl.value.trim().toLowerCase();
          update();
        }, 120);
      };
      searchEl.addEventListener('input', onType);
      searchEl.addEventListener('search', onType);      // native clear (×)
      searchEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); onType(); }
      });
    }

    if (sortSel) sortSel.addEventListener('change', function () { update(); });
    if (loadBtn) loadBtn.addEventListener('click', function () {
      shown += STEP;
      render();
    });

    /* Boot: pull every page once, then take over rendering. Until that resolves
       the server-rendered page 1 + numeric pager stay on screen, so there is no
       flash of an empty grid and no-JS still works. */
    root.classList.add('bl-js-on');
    ensureAll().then(function () { shown = STEP; render(); });

    if (resetBtn) resetBtn.addEventListener('click', function () {
      if (searchEl) searchEl.value = '';
      query = ''; activeCat = 'all';
      if (filters) filters.querySelectorAll('.bl-chip').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-cat') === 'all');
      });
      if (window.history && history.replaceState) history.replaceState(null, '', blogUrl);
      update();
    });
  }

  /* ------------------------- NEWSLETTER ------------------------- */
  function initNews(wrap) {
    if (wrap.hasAttribute('data-bl-ready')) return;   // section JS may be injected more than once
    wrap.setAttribute('data-bl-ready', '');
    var company = wrap.getAttribute('data-kl-company') || '';
    var list    = wrap.getAttribute('data-kl-list') || '';
    var msg     = wrap.querySelector('[data-bl-msg]');
    var okText  = wrap.getAttribute('data-ok')  || 'You’re on the list. Watch your inbox.';
    var errText = wrap.getAttribute('data-err') || 'Something went wrong. Please try again.';

    // No Klaviyo configured → the section rendered a native Shopify customer
    // form; let it submit normally and leave everything below alone.
    if (!company || !list) return;

    // Klaviyo path. The section deliberately renders NO <form> here (see the
    // comment in sections/lab-blog-newsletter.liquid). When it did, something
    // on the page natively POSTed that form to /contact behind our successful
    // fetch, reloading the page and painting Shopify's form.errors over the
    // success message. No form element = that cannot happen from any cause.
    // Bind the button and Enter instead.
    var emailEl = wrap.querySelector('[data-bl-email]');
    var btn     = wrap.querySelector('[data-bl-submit]');
    if (!emailEl || !btn) return;

    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.add('is-shown');
      msg.classList.toggle('is-ok', !!ok);
      msg.classList.toggle('is-err', !ok);
    }

    function subscribe() {
      var email = emailEl.value.trim();
      // No form element means no native constraint validation — do it here.
      if (!email || !emailEl.checkValidity()) { emailEl.reportValidity(); return; }
      if (btn.disabled) return;                       // already in flight
      btn.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        btn.disabled = false;
        if (res.ok || res.status === 202) {
          say(okText, true);
          emailEl.value = '';
        } else {
          say(errText, false);
        }
      }).catch(function () {
        btn.disabled = false;
        say(errText, false);
      });
    }

    btn.addEventListener('click', subscribe);
    emailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); subscribe(); }
    });
  }

  function boot() {
    document.querySelectorAll('[data-bl-articles]').forEach(initGrid);
    document.querySelectorAll('[data-bl-news-form]').forEach(initNews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
